import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useEffect, useMemo, useState } from 'react';
import { useTranslate } from 'lib/translate';
import User from '_class/User';
import { Floating } from '@haldor/ui';
import { useSelector, useDispatch } from 'react-redux';
import { PRESCHOOL } from 'constants/schoolTypes';
import { clearScheduleFilter, toggleAdvanceCalendar, UpdateFilter } from 'actions/ScheduleFilter';
import { Button, Checkbox, Icon, TooltipMenu } from '@haldor/ui';
import { Expandable, List } from 'UI';
import DropDownList from './DropDownList';
import ListSelector from './Partials/ListSelector';

var getLengthOfObject = function getLengthOfObject(object, user, isAdvanced) {
  if (user) {
    return Object.values(object).filter(function (item) {
      return item === true;
    }).length;
  }

  var total = Object.keys(object).filter(function (key) {
    return key != 'Meeting' && key != 'Assignment';
  }).reduce(function (obj, key) {
    obj[key] = object[key];
    return obj;
  }, {});
  var filterByTrue = Object.values(total).filter(function (item) {
    return item === true;
  }).length;
  return filterByTrue;
};

var getActivityLength = function getActivityLength(data, user) {
  var totalLength = user ? data.length : 1;

  if (!user) {
    data.forEach(function (element) {
      var _element$subMenu;

      element.subMenu ? totalLength += (_element$subMenu = element.subMenu) === null || _element$subMenu === void 0 ? void 0 : _element$subMenu.length : totalLength += 0;
    });
  }

  return totalLength;
};

var CalenderHeader = function CalenderHeader(props) {
  var translate = useTranslate();
  var overview = props.overview,
      toggleButtons = props.toggleButtons,
      goBack = props.goBack,
      toggleIcon = props.toggleIcon,
      notReportedSchedulePositions = props.notReportedSchedulePositions,
      toggleForm = props.toggleForm,
      isToday = props.isToday,
      goToday = props.goToday,
      isStudentCard = props.isStudentCard,
      displayAdvanced = props.displayAdvanced,
      goForward = props.goForward;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isActive = _useState2[0],
      setIsActive = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isIndeterminate = _useState4[0],
      setIsIndeterminate = _useState4[1];

  var dispatch = useDispatch();
  var school = useSelector(function (state) {
    return state.user.activeSchool;
  });
  var activities = useSelector(function (state) {
    return state.status.status.assignmentTypes;
  });
  var service = useSelector(function (state) {
    return state.Services.availableServices;
  });
  var user = useSelector(function (state) {
    return state.user.currentUser;
  });
  var ScheduleFilter = useSelector(function (state) {
    return state.ScheduleFilter;
  });
  var loggedInUser = useMemo(function () {
    return new User(user);
  }, []);
  var actvitiesLabels = useMemo(function () {
    return [{
      id: 'Lesson',
      value: 'lessons'
    }, {
      id: 'Assignment',
      value: 'Assignments',
      subMenu: !loggedInUser.isStudent() ? activities : []
    }, {
      id: 'Meeting',
      value: 'Meetings',
      subMenu: !loggedInUser.isStudent() ? ScheduleFilter.advancedCalendarActive ? [{
        id: 'booked',
        value: 'Booked meetings'
      }] : [{
        id: 'booked',
        value: 'Booked meetings'
      }, {
        id: 'unBooked',
        value: 'Unbooked meetings'
      }] : []
    }];
  }, [ScheduleFilter.advancedCalendarActive]); //fetch search group sections

  var handleActivity = function handleActivity(checked, name, parentId) {
    var obj = {};

    if (parentId) {
      var _obj2;

      if (checked) {
        var _obj;

        obj = (_obj = {}, _defineProperty(_obj, parentId, true), _defineProperty(_obj, name, checked), _obj);
        dispatch(UpdateFilter(false, obj));
        return;
      } //if not checked add one to update filter before redux has been updated


      var unchecked = checked ? 0 : 1;
      var items = actvitiesLabels.filter(function (x) {
        return x.id === parentId;
      });

      if (items.length > 0) {
        items[0].subMenu.forEach(function (element) {
          if (!(ScheduleFilter !== null && ScheduleFilter !== void 0 && ScheduleFilter.activitiesFilter[element.id])) {
            unchecked += 1;
          }
        });
      }

      obj = (_obj2 = {}, _defineProperty(_obj2, parentId, unchecked === items[0].subMenu.length ? false : true), _defineProperty(_obj2, name, checked), _obj2);
    } else {
      obj = _defineProperty({}, name, checked);
    }

    dispatch(UpdateFilter(false, obj));
  }; //handle checkbox for each group of activities


  var handleAllSub = function handleAllSub(checked, data, name, allButton) {
    var obj = {};

    if (checked) {
      for (var i = 0; i < data.length; i++) {
        obj[data[i].id] = true;
      }

      if (!allButton) {
        obj[name] = true;
      }
    } else {
      for (var _i = 0; _i < data.length; _i++) {
        obj[data[_i].id] = false;
      }

      if (!allButton) {
        obj[name] = false;
      }
    }

    if (allButton) {
      return obj;
    }

    dispatch(UpdateFilter(false, obj));
  }; //set all to checked as default if labels exists


  useEffect(function () {
    if (actvitiesLabels.length > 0) {
      allActivites(true, actvitiesLabels);
    }
  }, [actvitiesLabels]);

  var allActivites = function allActivites(checked, arrName, groups) {
    if (checked) {
      var _obj4 = {};

      for (var i = 0; i < arrName.length; i++) {
        if (groups) {
          _obj4[arrName[i].title] = true;
        } else {
          var _arrName$i$subMenu;

          _obj4[arrName[i].id] = true;

          if (((_arrName$i$subMenu = arrName[i].subMenu) === null || _arrName$i$subMenu === void 0 ? void 0 : _arrName$i$subMenu.length) > 0) {
            var sub = arrName[i].subMenu;
            var subValues = handleAllSub(true, sub, 0, true);
            _obj4 = _objectSpread(_objectSpread({}, _obj4), subValues);
          }
        }
      }

      dispatch(UpdateFilter(true, _obj4));
      return;
    }

    var obj = {};

    for (var _i2 = 0, _Object$entries = Object.entries(ScheduleFilter.activitiesFilter); _i2 < _Object$entries.length; _i2++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i2], 2),
          key = _Object$entries$_i[0],
          value = _Object$entries$_i[1];

      obj[key] = false;
      ScheduleFilter.activitiesFilter[key] = false;
    }

    dispatch(clearScheduleFilter(obj));
  };

  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "calendar-helper"
  }, /*#__PURE__*/React.createElement(Floating, {
    trigger: /*#__PURE__*/React.createElement(Icon, {
      name: "Help"
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "helper--content"
  }, /*#__PURE__*/React.createElement("strong", null, translate('Sign explanation')), /*#__PURE__*/React.createElement("div", {
    className: "helper--content--item df aic"
  }, /*#__PURE__*/React.createElement("div", {
    className: "checkbox-imitator",
    style: {
      backgroundColor: '#fff'
    }
  }), translate('My activities')), /*#__PURE__*/React.createElement("div", {
    className: "helper--content--item df aic"
  }, /*#__PURE__*/React.createElement("div", {
    className: "checkbox-imitator",
    style: {
      backgroundColor: '#ededed'
    }
  }), translate('Other peoples activities')), /*#__PURE__*/React.createElement("div", {
    className: "helper--content--item df aic"
  }, /*#__PURE__*/React.createElement("div", {
    className: "checkbox-imitator",
    style: {
      backgroundColor: '#fff',
      borderLeftWidth: 3,
      borderLeftColor: '#027adc'
    }
  }), translate('Lesson')), /*#__PURE__*/React.createElement("div", {
    className: "helper--content--item df aic"
  }, /*#__PURE__*/React.createElement("div", {
    className: "checkbox-imitator",
    style: {
      backgroundColor: '#fff',
      borderLeftWidth: 3,
      borderLeftColor: '#ea4b9a'
    }
  }), translate('Test'))))), /*#__PURE__*/React.createElement("div", {
    className: "calenderToolBar"
  }, overview && isStudentCard ? /*#__PURE__*/React.createElement("div", {
    className: "calendar-title-overView"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "Calendar"
  }), /*#__PURE__*/React.createElement("span", {
    className: "schedule-title"
  }, translate('schedule-header-overview'))) : null, toggleButtons(), /*#__PURE__*/React.createElement("div", {
    className: "navigation-buttons-container"
  }, /*#__PURE__*/React.createElement(Button, {
    type: "secondary",
    style: {
      marginLeft: 0,
      marginRight: '0.5em'
    },
    onClick: goBack
  }, toggleIcon(false), "\xA0"), /*#__PURE__*/React.createElement(Button, {
    type: "secondary",
    disabled: isToday,
    style: {
      marginRight: '0.5em',
      marginLeft: 0
    },
    onClick: goToday
  }, translate('today')), /*#__PURE__*/React.createElement(Button, {
    type: "secondary",
    style: {
      marginLeft: 0
    },
    onClick: goForward
  }, toggleIcon(true), "\xA0"), overview && !loggedInUser.isStudent() ? /*#__PURE__*/React.createElement("div", {
    style: {
      marginLeft: '1rem'
    },
    className: "dashboard-create"
  }, !(loggedInUser !== null && loggedInUser !== void 0 && loggedInUser.isStudent()) && !isStudentCard && !props.noCreate ? service.advancedSchedule && school.type != PRESCHOOL ? /*#__PURE__*/React.createElement(TooltipMenu, {
    trigger: /*#__PURE__*/React.createElement(Button, {
      type: "secondary"
    }, /*#__PURE__*/React.createElement(Icon, {
      name: "Plus"
    }), " ", translate('Create'))
  }, /*#__PURE__*/React.createElement(TooltipMenu.Item, {
    onClick: function onClick() {
      return toggleForm();
    }
  }, translate('create-lesson')), /*#__PURE__*/React.createElement(TooltipMenu.Item, {
    onClick: function onClick() {
      return props.toggleAssignment();
    }
  }, translate('Create assignment')), /*#__PURE__*/React.createElement(TooltipMenu.Item, {
    onClick: function onClick() {
      return props.toggleGroupAssignment();
    }
  }, translate('Create group assignment'))) : /*#__PURE__*/React.createElement(Button, {
    type: "secondary",
    onClick: function onClick() {
      return toggleForm();
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "Plus"
  }), " ", translate('Create')) : null) : null), service.advancedSchedule && school.type != PRESCHOOL ? /*#__PURE__*/React.createElement("div", {
    className: "filtering"
  }, ScheduleFilter.advancedCalendarActive && !loggedInUser.isStudent() && displayAdvanced ? /*#__PURE__*/React.createElement("div", {
    className: "filter-activties"
  }, /*#__PURE__*/React.createElement("span", {
    className: "filter-headline"
  }, translate('select students')), /*#__PURE__*/React.createElement(DropDownList, {
    label: "".concat(translate('Displaying'), " ").concat(ScheduleFilter === null || ScheduleFilter === void 0 ? void 0 : ScheduleFilter.selectedPeople, " ").concat(translate('students').toLowerCase(), ", ").concat(ScheduleFilter.ownersSelected, " ").concat(translate('owners').toLowerCase()),
    offset: 15,
    placement: 'bottom'
  }, /*#__PURE__*/React.createElement(ListSelector, null))) : null, !props.noFilter ? /*#__PURE__*/React.createElement("div", {
    className: "filter-activties"
  }, /*#__PURE__*/React.createElement("span", {
    className: "filter-headline"
  }, translate('select activities')), /*#__PURE__*/React.createElement(DropDownList, {
    label: "".concat(translate('Displaying'), " ").concat(getLengthOfObject(ScheduleFilter === null || ScheduleFilter === void 0 ? void 0 : ScheduleFilter.activitiesFilter, loggedInUser.isStudent(), ScheduleFilter.advancedCalendarActive), " ").concat(translate('of'), " ").concat(getActivityLength(actvitiesLabels, loggedInUser.isStudent())),
    offset: 15,
    OffsetX: true,
    placement: 'bottom-end'
  }, /*#__PURE__*/React.createElement(Checkbox, {
    value: ScheduleFilter.allFilter,
    onChange: function onChange(value) {
      return allActivites(value, actvitiesLabels);
    },
    label: translate('Select all')
  }), /*#__PURE__*/React.createElement("ul", {
    className: "filterModal"
  }, actvitiesLabels.map(function (item) {
    var _item$subMenu, _item$subMenu2;

    return ((_item$subMenu = item.subMenu) === null || _item$subMenu === void 0 ? void 0 : _item$subMenu.length) > 0 ? /*#__PURE__*/React.createElement(Expandable, {
      key: item.id,
      contentStyles: {
        padding: 0
      },
      contentStylesClosed: {
        padding: '0'
      },
      headerStyles: {
        border: 'none'
      },
      title: /*#__PURE__*/React.createElement(Checkbox, {
        value: ScheduleFilter.activitiesFilter[item.id],
        onChange: function onChange(value) {
          return handleAllSub(value, item.subMenu, item.id);
        },
        label: translate(item.value)
      })
    }, item === null || item === void 0 ? void 0 : (_item$subMenu2 = item.subMenu) === null || _item$subMenu2 === void 0 ? void 0 : _item$subMenu2.map(function (items) {
      return ScheduleFilter.advancedCalendarActive && item.id === 'unBooked' ? /*#__PURE__*/React.createElement("div", null) : /*#__PURE__*/React.createElement(List, {
        key: items.id
      }, /*#__PURE__*/React.createElement(Checkbox, {
        value: ScheduleFilter.activitiesFilter[items.id],
        onChange: function onChange(value) {
          return handleActivity(value, items.id, item.id);
        },
        label: translate(items.value)
      }));
    })) : /*#__PURE__*/React.createElement(Checkbox, {
      key: item.id,
      value: ScheduleFilter.activitiesFilter[item.id],
      onChange: function onChange(value) {
        return handleActivity(value, item.id);
      },
      label: translate(item.value)
    });
  })))) : null, /*#__PURE__*/React.createElement("div", {
    className: "checkBoxWrapper"
  }, !isStudentCard && displayAdvanced && service.advancedSchedule && school.type != PRESCHOOL ? /*#__PURE__*/React.createElement("div", {
    className: "checkBoxContainer"
  }, /*#__PURE__*/React.createElement(Checkbox, {
    value: ScheduleFilter.advancedCalendarActive,
    onChange: function onChange() {
      return dispatch(toggleAdvanceCalendar());
    },
    label: /*#__PURE__*/React.createElement("div", {
      className: "size-16"
    }, translate('Advanced mode'))
  })) : null)) : null, notReportedSchedulePositions()));
};

export default CalenderHeader;